class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><g clip-path="url(#a)"><path d="m14.05 9.448-7.5-7.5c-1.25-1.3-3.3-1.3-4.6-.05a3.2 3.2 0 0 0 0 4.6l.05.05 1.4 1.45.7-.7-1.45-1.45c-.85-.85-.85-2.3 0-3.15.85-.85 2.3-.9 3.15-.05l.05.05 7.45 7.45c.9.85.9 2.3.05 3.15-.85.9-2.3.9-3.15.05l-.05-.05-3.7-3.7c-.5-.5-.45-1.3 0-1.75.5-.45 1.25-.45 1.75 0l3.05 3.05.7-.7-3.1-3.1c-.9-.85-2.3-.8-3.15.1-.8.85-.8 2.2 0 3.1l3.75 3.75c1.25 1.3 3.3 1.3 4.6.05 1.3-1.25 1.3-3.35 0-4.65Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs></svg>';
  }
}
const t = "pi-attachment";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
